const CalcTime = (idTrivia, idTrivia2)=>{
    let initTime;
    let interval;
    
    const timeTrivia = document.querySelector(`${idTrivia ? idTrivia : "#trivia-questions"} .time p`);
    const buttons = document.querySelectorAll(`${idTrivia2 ? idTrivia2 : "#render-questions"} .block .btn`);

    buttons.forEach((button)=>{
        button.addEventListener('click', ()=>{
            const time = stopCounter();
            button.dataset.time = time;
        });
    })
    
    function initCounter() {
        let seconds = 10;
        initTime = Date.now(); // Guardar el tiempo actual en miliseconds
        interval = setInterval(function() {
            seconds--;
            if (seconds >= 0) {
                timeTrivia.textContent = `00:${seconds}:00`;
            } else {
                const button = document.querySelector(`${idTrivia ? idTrivia : "#trivia-questions"} .block.active .btn`)
                button && button.click();
                timeTrivia.textContent = `00:10:00`;
                stopCounter();
            }
        }, 1000);
    }
    
    function stopCounter() {
        //Calc miliseconds
        let totalTime = Date.now() - initTime; 
        //Reset counter
        clearInterval(interval); 
        initCounter();
        //Set content
        timeTrivia.textContent = `00:10:00`;

        return totalTime;
    }

    buttons[0] && initCounter();
}

const  miliSeconds = (miliseconds) => {
    return miliseconds / 1000; 
}
  
const  minutes = (segundos) => {
    let minutes = Math.floor(segundos / 60); 
    let restSeconds = segundos % 60; 
    let miliSeconds = (restSeconds % 1).toString().slice(2);
    let recortNumber = miliSeconds.slice(0, 3); 
    if (segundos >= 60) {

        return `0${minutes}:${parseInt(restSeconds) < 10 ? "0" + parseInt(restSeconds) : parseInt(restSeconds)}:${ recortNumber.length == 0 ? "00" : recortNumber}`;
    } else {
        return `00:${parseInt(segundos)}:${ recortNumber.length == 0 ? "00" : recortNumber}`;
    }
}


export { CalcTime, miliSeconds, minutes }